module.exports = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined';



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/array-buffer-native.js
// module id = 266
// module chunks = 3